<h1 class="page-title">Reset Password</h1>
<form *ngIf="!resetPasswordSuccess" class="form sign-in-form" [formGroup]="passwordForm"
      (ngSubmit)="onSubmit(passwordForm.value)">
  <p>Enter a new password for your account.</p>
  <div class="field ">
    <label for="password" class="label">New Password</label>
    <input class="input" formControlName="password" id="password" name="password" type="password" placeholder=""
           autocomplete="off" required/>
    <div *ngIf="formMessages.password" class="error-message field__error-message">{{ formMessages.password }}</div>
  </div>
  <div class="field ">
    <label for="confirmation" class="label">Retype Password</label>
    <input class="input" formControlName="confirmation" id="confirmation" appValidateEqual="password" name="confirmation"
           type="password" placeholder="" autocomplete="off" required/>
    <div *ngIf="formMessages.confirmation" class="error-message field__error-message">{{ formMessages.confirmation
      }}
    </div>
  </div>
  <input class="button" type="submit" value="Reset Password">
  <div *ngIf="formError" class="error-message field__error-message">{{formError}}</div>
</form>
<div *ngIf="resetPasswordSuccess">
  <p>Your password has been changed successfully.</p>
  <button type="button" class="button" routerLink="/">Sign In</button>
</div>
